import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'sb-portal-welcome',
  templateUrl: './portal-welcome.component.html',
  styleUrls: ['./portal-welcome.component.scss']
})
export class PortalWelcomeComponent implements OnInit{

  @Input()
  firstName: string = "";

  ngOnInit() {
    if (!this.firstName) {
      this.firstName = (window as any).NG_SHARED_USER_SERVICE.firstName;
    }
  }
}
